import { createSelector } from 'reselect';

export const getSelectedForm = state => state.leadAds.selected;
export const getLeadSource = state => state.leadAds.source;
export const getLeadAdEnabled = state => state.leadAds.isEnabled;

export const getLeadFormSelected = createSelector(
  getSelectedForm,
  form => !!form,
);
